import { render, staticRenderFns } from "./工资条发放.vue?vue&type=template&id=4840f0d5&scoped=true&"
import script from "./工资条发放.vue?vue&type=script&lang=js&"
export * from "./工资条发放.vue?vue&type=script&lang=js&"
import style0 from "./工资条发放.vue?vue&type=style&index=0&id=4840f0d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840f0d5",
  null
  
)

export default component.exports